import Footer from './components/templateParts/Footer/Footer'
import Header from './components/templateParts/Header'
import SiteIntro from './components/templateParts/SiteIntro/SiteIntro'
import useStore from './hooks/useStore'
import './layout.scoped.scss'
import PropTypes from 'prop-types'
import React, { useState, useEffect, createContext } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Lenis from '@studio-freight/lenis'
import ReactGA from 'react-ga4'

Layout.propTypes = {
  children: PropTypes.any,
}

export const context = createContext()

export default function Layout({ children }) {
  const { appState, acfOptions } = useStore()
  // const { introShown } = useIntro()
  const [isOpened, setIsOpened] = useState(false)
  const [introShown, setIntroShown] = useState(false)
  const [scrollLenis, setScrollLenis] = useState(0)
  const location = useLocation()
  const options = acfOptions()
  // const slug = location.pathname.replaceAll('/', '')
  const gacode = options?.ga_code
  const [bannerIsHidden, setBannerIsHidden] = useState(
    localStorage.getItem('isHidden') === 'true' || false,
  )

  const handleCloseBanner = () => {
    setBannerIsHidden(true)
    localStorage.setItem('isHidden', 'true')
  }

  if (gacode) {
    ReactGA.initialize([
      {
        trackingId: gacode,
      },
    ])
  }

  const toggleIsOpened = (open = 'false') => {
    if (open === 'false') {
      setIsOpened(false)
    } else if (open === 'true') {
      setIsOpened(true)
    } else if (open === 'toggle') {
      setIsOpened((prev) => !prev)
    }
  }

  const toggleScroll = (scroll = false) => {
    if (scroll === false) {
      lenisInstance.stop()
    } else {
      lenisInstance.start()
    }
  }

  const [lenisInstance] = useState(new Lenis())

  useEffect(() => {
    toggleIsOpened('false')
    // Google Analytics
    if (gacode) {
      ReactGA.send({ hitType: 'pageview', page: location.pathname })
    }
  }, [location])

  useEffect(() => {
    setTimeout(() => {
      if (location.search) {
        const urlParams = new URLSearchParams(location.search)
        const target = urlParams.get('anchor')
        lenisInstance.scrollTo(`#${target}`, { offset: -200 })
      } else {
        lenisInstance.scrollTo('top', { immediate: true })
      }
    }, 200)
  }, [location])

  useEffect(() => {
    if (lenisInstance) requestAnimationFrame(raf)
  }, [lenisInstance])

  useEffect(() => {
    if (isOpened) {
      lenisInstance.stop()
    } else {
      lenisInstance.start()
    }
  }, [isOpened])

  useEffect(() => {
    if (!introShown) {
      lenisInstance.stop()
    } else {
      lenisInstance.start()
    }
  }, [introShown])

  const raf = (time) => {
    lenisInstance.raf(time)
    requestAnimationFrame(raf)
  }

  const setIntroComplete = () => {
    setIntroShown(true)
    sessionStorage.setItem('introShown', true)
  }

  useEffect(() => {
    const value = sessionStorage.getItem('introShown')
    if (value) setIntroShown(value)
  }, [introShown])

  useEffect(() => {
    lenisInstance.on('scroll', (e) => {
      setScrollLenis(e.animatedScroll)
    })
  }, [])

  return (
    <context.Provider
      value={{
        appState,
        isOpened,
        toggleIsOpened,
        lenisInstance,
        introShown,
        setIntroComplete,
        toggleScroll,
        bannerIsHidden,
        handleCloseBanner,
        scrollLenis,
      }}
    >
      <SiteIntro />

      <div id="website-wrapper">
        <Header isOpened={isOpened} toggleIsOpened={toggleIsOpened} />
        <div id="website-content">
          <Outlet />
          {children}
        </div>
        <Footer />
      </div>
    </context.Provider>
  )
}
